/**
 * Created by CCristi <ccovali@mitocgroup.com> on 12/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloudFrontDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get2 = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AbstractFsDriver2 = require('./AbstractFsDriver');

var _MethodNotAvailableException = require('./Exception/MethodNotAvailableException');

var _SharedKey = require('../SharedKey');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * CloudFront Cache Driver
 */
let CloudFrontDriver = exports.CloudFrontDriver = function (_AbstractFsDriver) {
  _inherits(CloudFrontDriver, _AbstractFsDriver);

  /**
   * @todo: Find better way to extract the working microservice identifier
   *
   * @param {ContainerAware} containerAware
   * @param {String} directory
   */
  function CloudFrontDriver(containerAware) {
    let directory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _AbstractFsDriver2.AbstractFsDriver.DEFAULT_DIRECTORY;

    _classCallCheck(this, CloudFrontDriver);

    var _this = _possibleConstructorReturn(this, (CloudFrontDriver.__proto__ || Object.getPrototypeOf(CloudFrontDriver)).call(this, directory));

    _this._containerAware = containerAware;
    _this._cache = {};
    return _this;
  }

  /**
   * @returns {String}
   * @private
   */


  _createClass(CloudFrontDriver, [{
    key: '_type',
    value: function _type() {
      return 'CloudFront';
    }

    /**
     * @param {String} key
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_has',
    value: function _has(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      this._get(key, (err, data) => {
        callback(err, data !== null);
      });
    }

    /**
     * @todo: Find a way to invalidate broken or expired keys
     *
     * @param {String} key
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_get',
    value: function _get(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      // @todo: get rid of this cache?
      if (this._cache.hasOwnProperty(key)) {
        let parsedData = this._cache[key];

        if (parsedData.expires && parsedData.expires < _AbstractFsDriver2.AbstractFsDriver._now || parsedData.buildId !== this._buildId) {
          delete this._cache[key];
        } else {
          callback(null, this._cache[key].value);
          return;
        }
      }

      this._request(key, (err, data) => {
        if (err) {
          return callback(err, null);
        }

        try {
          let parsedData = JSON.parse(data);

          if (parsedData.expires && parsedData.expires < _AbstractFsDriver2.AbstractFsDriver._now || parsedData.buildId !== this._buildId) {
            callback(null, null);

            return;
          }

          this._cache[key] = parsedData;

          callback(null, parsedData.value);
        } catch (e) {
          // avoid parse error on missing or broken object in S3
          callback(null, null);
        }
      });
    }

    /**
     * Throw MethodNotAvailableException
     *
     * @private
     */

  }, {
    key: '_set',
    value: function _set() {
      throw new _MethodNotAvailableException.MethodNotAvailableException('set');
    }

    /**
     * Throw MethodNotAvailableException
     *
     * @private
     */

  }, {
    key: '_invalidate',
    value: function _invalidate() {
      throw new _MethodNotAvailableException.MethodNotAvailableException('invalidate');
    }

    /**
     * @param {String|Key} key
     * @returns {String}
     * @private
     */

  }, {
    key: '_buildKey',
    value: function _buildKey(key) {
      return key instanceof _SharedKey.SharedKey ? this._asset.locate(`@${key.microservice}:${_get2(CloudFrontDriver.prototype.__proto__ || Object.getPrototypeOf(CloudFrontDriver.prototype), '_buildKey', this).call(this, key.toString())}`) : this._asset.locate(`@${this._microservice}:${_get2(CloudFrontDriver.prototype.__proto__ || Object.getPrototypeOf(CloudFrontDriver.prototype), '_buildKey', this).call(this, key)}`);
    }

    /**
     * @param {String} url
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_request',
    value: function _request(url, callback) {
      var client = new XMLHttpRequest();

      client.onreadystatechange = function () {
        if (client.readyState === 4) {
          if (client.status !== 200) {
            return callback(client.statusText, null);
          }

          callback(null, client.responseText);
        }
      };

      client.open('GET', url);
      client.send();
    }

    /**
     * Returns the microservice binded to `resource` service
     *
     * @returns {Instance}
     * @private
     */

  }, {
    key: '_microservice',
    get: function get() {
      return this._containerAware.container.get('resource').microservice;
    }

    /**
     * @returns {Asset}
     * @private
     */

  }, {
    key: '_asset',
    get: function get() {
      return this._containerAware.container.get('asset');
    }
  }]);

  return CloudFrontDriver;
}(_AbstractFsDriver2.AbstractFsDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/CloudFrontDriver.js
// module id = 347
// module chunks = 0